// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root-portal{
    position: fixed;
    z-index: 3543543443;
    left: 0;
    right: 0;
}
/* Remove unwanted background overlay */
  
  /* Page container */
  .page-container {
    text-align: center;
    padding: 20px;
  }
  
  /* Button to open modal */
  .open-btn {
    padding: 10px 20px;
    background: var(--referral-blue-background2);
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }
  .react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name{
    margin: 6px;
  }
  /* Modal background */
  .datepicker-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4); /* Light overlay */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .react-datepicker-popper{
    transform: none !important;
    padding: 20px;
    width: 100%;
    line-height: normal;
  }
  .custom-calendar-container{
    background: var(--white);
    border-radius: 16px;
    overflow: hidden;
  }
.react-datepicker__day-names, .react-datepicker__month{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0px;
}
.react-datepicker__month{
    flex-direction: column;
}
.react-datepicker__day-names > div{
    flex: 1 1;
    font-size: 12px;
    font-weight: 500;
}
.react-datepicker__month .react-datepicker__week > div{
    flex: 1 1;
    font-size: 12px;
    font-weight: 500;
}
.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, .react-datepicker__year-text--in-range, .react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected{
    background-color: var(--referral-blue-background2);
    color: var(--white);
    line-height: 33px;
    border-radius: 50%;
    width: auto;
    height: auto;
}
.react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected{
    background-color: var(--referral-blue-background2);
}
.react-datepicker__input-container input:focus, .react-datepicker__input-container input:active, .react-datepicker__input-container input:focus-visible{
  border: none;
  outline: none;
  box-shadow: none;
}
.react-datepicker__week{
    width: 100%;
    display: flex;
        justify-content: center;
        align-items: center;
}
.react-datepicker__day-name{
    display: flex;
    justify-content: center;
    align-items: center;
}
  .custom-header-year-date{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: var(--referral-blue-background2);
    flex-direction: column;
    height: 70px;
    padding: 12px;
  }
  .month-controls{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
  }
  .react-datepicker__header {
    text-align: center;
    border-bottom: 0;
    border-top-left-radius: 0;
    padding: 0px;
    background-color:transparent;
    position: relative;
}
.react-datepicker__month-container {
    float: none;
}
.react-datepicker__triangle{
    display: none;
}
  #datepicker-portal{
    position: fixed;
    top: 0%;
    left: 0;
    right: 0;
    z-index: 3234343;
    margin-top: 13%;
  }
  /* Centered datepicker */
  .datepicker-content {
    background: white;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
    padding: 20px;
    width: 320px;
  }
  
  /* Footer with OK and CANCEL buttons */
  .calendar-footer {
    display: flex;
    justify-content: flex-end;
    padding: 15px 10px;
  }

  .react-datepicker__month {
    margin: auto; 
}
  
  .cancel-btn {
    color: var(--referral-blue-background2);
    border: none;
    background: transparent;
    cursor: pointer;
    font-weight: bold;
    margin-right: 20px;
  }
  
  .ok-btn {
    color:  var(--referral-blue-background2); 
    border: none;
    background: transparent;
    font-weight: bold;
    cursor: pointer;
    margin-right: 5px;
  }

@media (min-width: 400px) {
    #datepicker-portal {
      margin-top: 5%;
  }
  .month-controls {
    padding: 10px 20px;
  }
  .calendar-footer {
    padding: 5px 10px 15px;
  }
  
  }

@media (max-width: 325px) {
  #datepicker-portal {
    margin-top: 5%;
}
.month-controls {
  padding: 10px 20px;
}
.calendar-footer {
  padding: 5px 10px 15px;
}

}`, "",{"version":3,"sources":["webpack://./src/components/Calender/extra.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,mBAAmB;IACnB,OAAO;IACP,QAAQ;AACZ;AACA,uCAAuC;;EAErC,mBAAmB;EACnB;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA,yBAAyB;EACzB;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA,qBAAqB;EACrB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B,EAAE,kBAAkB;IAClD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,aAAa;IACb,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;EAClB;AACF;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kDAAkD;IAClD,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,kDAAkD;AACtD;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;IACI,WAAW;IACX,aAAa;QACT,uBAAuB;QACvB,mBAAmB;AAC3B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,kDAAkD;IAClD,sBAAsB;IACtB,YAAY;IACZ,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;EACE;IACE,eAAe;IACf,OAAO;IACP,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,eAAe;EACjB;EACA,wBAAwB;EACxB;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,2CAA2C;IAC3C,aAAa;IACb,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,YAAY;AAChB;;EAEE;IACE,uCAAuC;IACvC,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,wCAAwC;IACxC,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;;AAEF;IACI;MACE,cAAc;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;;EAEA;;AAEF;EACE;IACE,cAAc;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;;AAEA","sourcesContent":[".root-portal{\n    position: fixed;\n    z-index: 3543543443;\n    left: 0;\n    right: 0;\n}\n/* Remove unwanted background overlay */\n  \n  /* Page container */\n  .page-container {\n    text-align: center;\n    padding: 20px;\n  }\n  \n  /* Button to open modal */\n  .open-btn {\n    padding: 10px 20px;\n    background: var(--referral-blue-background2);\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n  }\n  .react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name{\n    margin: 6px;\n  }\n  /* Modal background */\n  .datepicker-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.4); /* Light overlay */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .react-datepicker-popper{\n    transform: none !important;\n    padding: 20px;\n    width: 100%;\n    line-height: normal;\n  }\n  .custom-calendar-container{\n    background: var(--white);\n    border-radius: 16px;\n    overflow: hidden;\n  }\n.react-datepicker__day-names, .react-datepicker__month{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0px;\n}\n.react-datepicker__month{\n    flex-direction: column;\n}\n.react-datepicker__day-names > div{\n    flex: 1;\n    font-size: 12px;\n    font-weight: 500;\n}\n.react-datepicker__month .react-datepicker__week > div{\n    flex: 1;\n    font-size: 12px;\n    font-weight: 500;\n}\n.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, .react-datepicker__year-text--in-range, .react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected{\n    background-color: var(--referral-blue-background2);\n    color: var(--white);\n    line-height: 33px;\n    border-radius: 50%;\n    width: auto;\n    height: auto;\n}\n.react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected{\n    background-color: var(--referral-blue-background2);\n}\n.react-datepicker__input-container input:focus, .react-datepicker__input-container input:active, .react-datepicker__input-container input:focus-visible{\n  border: none;\n  outline: none;\n  box-shadow: none;\n}\n.react-datepicker__week{\n    width: 100%;\n    display: flex;\n        justify-content: center;\n        align-items: center;\n}\n.react-datepicker__day-name{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n  .custom-header-year-date{\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    background-color: var(--referral-blue-background2);\n    flex-direction: column;\n    height: 70px;\n    padding: 12px;\n  }\n  .month-controls{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n  }\n  .react-datepicker__header {\n    text-align: center;\n    border-bottom: 0;\n    border-top-left-radius: 0;\n    padding: 0px;\n    background-color:transparent;\n    position: relative;\n}\n.react-datepicker__month-container {\n    float: none;\n}\n.react-datepicker__triangle{\n    display: none;\n}\n  #datepicker-portal{\n    position: fixed;\n    top: 0%;\n    left: 0;\n    right: 0;\n    z-index: 3234343;\n    margin-top: 13%;\n  }\n  /* Centered datepicker */\n  .datepicker-content {\n    background: white;\n    border-radius: 15px;\n    overflow: hidden;\n    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);\n    padding: 20px;\n    width: 320px;\n  }\n  \n  /* Footer with OK and CANCEL buttons */\n  .calendar-footer {\n    display: flex;\n    justify-content: flex-end;\n    padding: 15px 10px;\n  }\n\n  .react-datepicker__month {\n    margin: auto; \n}\n  \n  .cancel-btn {\n    color: var(--referral-blue-background2);\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    font-weight: bold;\n    margin-right: 20px;\n  }\n  \n  .ok-btn {\n    color:  var(--referral-blue-background2); \n    border: none;\n    background: transparent;\n    font-weight: bold;\n    cursor: pointer;\n    margin-right: 5px;\n  }\n\n@media (min-width: 400px) {\n    #datepicker-portal {\n      margin-top: 5%;\n  }\n  .month-controls {\n    padding: 10px 20px;\n  }\n  .calendar-footer {\n    padding: 5px 10px 15px;\n  }\n  \n  }\n\n@media (max-width: 325px) {\n  #datepicker-portal {\n    margin-top: 5%;\n}\n.month-controls {\n  padding: 10px 20px;\n}\n.calendar-footer {\n  padding: 5px 10px 15px;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
